define('views/peoplefinder/Podio.Views.PeopleFinder.Main',['require','translate','underscore','jquery','lib/Podio.Config','views/lib/Podio.Views.SideTabsLinkedAccountsLayout','jst!peoplefinder/_modal','jst!peoplefinder/_sharefile_limited_modal'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  var podioConfig = require('lib/Podio.Config');
  var sideTabsLinkedAccountsLayout = require('views/lib/Podio.Views.SideTabsLinkedAccountsLayout');

  var jstModal = require('jst!peoplefinder/_modal');
  var sfLimitedModal = require('jst!peoplefinder/_sharefile_limited_modal');

  return sideTabsLinkedAccountsLayout.extend({
    shortcuts : {
      'esc' : 'onEscShortcutTriggered'
    },

    show: function() {
      // render the modal frame
      var modalTemplate = podioConfig.user.from_sharefile ? sfLimitedModal : jstModal;
      var mainView = $(this.getTemplate(modalTemplate)).appendTo($('body'));

      // setup data for the sideTabsLayout
      this.elmMain = mainView.find('.inner-content');
      this.setElement(mainView.get(0));
      this.elm = mainView;
      this.navigationOptions = this.getNavigationOptions();

      if (this.navigationOptions[0]) {
        this.navigationSelectedItem = this.navigationOptions[0].id;
      }

      // render linked accounts, if enabled
      var linkedAccountsConfig = _.find(this.options.config, function(c) {
        return c.type === 'linkedAccounts';
      });
      if (linkedAccountsConfig && linkedAccountsConfig.visible) {
        this.dfdInitDone = this.initLayout('contacts');
      } else {
        this.initTabsLayout();
        this.dfdInitDone = new $.Deferred().resolve();
      }

      this.enableShortcuts();

      return this.dfdInitDone;
    },

    onEscShortcutTriggered: function() {
      this.hide();
    },

    getFirstNavigationOption: function() {
      return this.navigationOptions[0];
    },

    getNavigationOptions: function() {
      var options = [];
      var config = this.options.config;

      var configMap = {
        podio: {
          id: 'podio',
          label: t('Podio #peoplefinder'),
          icon: 'icon-podiologo'
        },
        mail: {
          id: 'mail',
          label: t('Email #peoplefinder'),
          icon: 'icon-mail-light'
        },
        podioSpaceMembers: {
          id: 'podioSpaceMembers',
          label: t('Podio space users #peoplefinder'),
          icon: 'icon-podiologo'
        },
        podioSpaceContacts: {
          id: 'podioSpaceContacts',
          label: t('Podio space contacts #peoplefinder'),
          icon: 'icon-podiologo'
        }
      };

      _.each(config, function(c) {
        if (configMap[c.type]) {
          options.push(configMap[c.type]);
        }
      });

      return options;
    },

    dispose: function() {
      this.disposeTabsLayout();
      this._super();
    },

    showFirstLinkedAccount: function() {
      if (this.accountProviders && this.accountProviders.models.length) {
        var firstLinkedAccountProviderName = this.accountProviders.models[0].get('name');
        this.renderProvider(firstLinkedAccountProviderName);
        this.selectNavItem(firstLinkedAccountProviderName);
      }
    }
  });

});

